import React, { useContext, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ScheduleIcon from '../../../assets/img/svg/schedule-icon.svg'
import CleanerUserIcon from '../../../assets/img/svg/users-icon.svg'
import ShawerIcon from '../../../assets/img/svg/shawer-icon.svg'
import BadIcon from '../../../assets/img/svg/bad-icon.svg'
import { Button } from 'reactstrap'
import CustomModal from '../../../component/customModal'
import AddEditSchedule from './addEditSchedule'
import DeletePopup from '../../../component/deletePopup'
import AddEditiCal from './addEditiCal'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { deleteProperty } from '../../../redux/slices/propertySlice'
import { getBookingDayjs, formatAmount, getUserRole, hasAccess } from '../../../helper/function'
import EditMainCleaner from './editModels/editMainCleaner'
import EditTotalValue from './editModels/editTotalValue'
import EditCleanerServiceValue from './editModels/editCleanerServiceValue'

const Property = ({ setIsRefresh, client_id, properties, setUpcomingRefresh }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const [showiCalModal, setShowiCalModal] = useState(false)
  const [propertyId, setPropertyId] = useState([])
  const [propertyData, setPropertyData] = useState({})
  const [cleaning_on, setCleaning_on] = useState(null)
  const toggleiCalModal = () => setShowiCalModal(!showiCalModal)
  const { clientInfo } = useSelector(({ client }) => client)
  const { client } = clientInfo
  const disableIcal = useMemo(() => !client?.invoice_payment && !client?.is_card && !client?.is_ghost, [client])

  // Schedule Modal
  const [showScheduleModal, setShowScheduleModal] = useState(false)
  const toggleScheduleModal = () => setShowScheduleModal(!showScheduleModal)

  // Main Cleaner Modal
  const [showMainCleanerModal, setShowMainCleanerModal] = useState(false)
  const toggleMainCleanerModal = () => setShowMainCleanerModal(!showMainCleanerModal)

  // Total Value Modal
  const [showTotalValueModal, setShowTotalValueModal] = useState(false)
  const toggleTotalValueModal = () => setShowTotalValueModal(!showTotalValueModal)

  // Cleaner Service Value Modal
  const [showCleanerServiceValueModal, setShowCleanerServiceValueModal] = useState(false)
  const toggleCleanerServiceValueModal = () => setShowCleanerServiceValueModal(!showCleanerServiceValueModal)

  const onDelete = () => {
    if (propertyId) {
      changeLoader(true)
      dispatch(deleteProperty(propertyId))
        .then(() => {
          changeLoader(false)
        })
        .catch((err) => {
          console.log('err :>> ', err)
          changeLoader(false)
        })
    }
  }

  return (
    <>
      <div>
        {hasAccess('propertyAccess', getUserRole()) && (
          <div className="common_heading_div">
            <h4>Properties</h4>
            <Button className="btn btn-primary" type="button" onClick={() => navigate(`/clients/clientInfo/${client_id}/add-property`)}>
              New Property
            </Button>
          </div>
        )}
        {properties?.length ? (
          <div className="property_scroll_div">
            {properties?.map((property, index) => (
              <div className="common_card_div" key={index}>
                <div className="property_action_div">
                  <div className="mb-2">
                    <h5 className="mb-1">{property?.property_name}</h5>
                    <p className="fs-14 gray_color fw-400 mb-2">
                      {property?.address} - {property?.city}
                    </p>
                    <div className="amount_div">
                      <label className="cleanings_icon_box_div">
                        <img className="img-fluid" src={ShawerIcon} alt="Image" />
                        {property?.number_of_bathroom}
                      </label>
                      <label className="cleanings_icon_box_div">
                        <img className="img-fluid" src={BadIcon} alt="Image" />
                        {property?.number_of_rooms}
                      </label>
                    </div>
                  </div>
                  <div className="property_btn_div">
                    <Button
                      className="btn btn-secondary"
                      type="button"
                      onClick={() => {
                        navigate(`/clients/clientInfo/${client_id}/view-history/${property?.properties_id}`)
                      }}
                    >
                      Cleaning History
                    </Button>
                    {hasAccess('scheduleButtonAccess', getUserRole()) && (
                      <Button
                        className="btn btn-primary"
                        type="button"
                        onClick={() => {
                          setPropertyId(property?.properties_id)
                          setPropertyData(property)
                          toggleScheduleModal()
                          setCleaning_on(property?.cleaning_on)
                        }}
                      >
                        <i className="far fa-calendar-alt me-1"></i>
                        Schedule
                      </Button>
                    )}
                    {hasAccess('iCallAccess', getUserRole()) && (
                      <Button
                        className="btn btn-primary dark_gray_btn"
                        type="button"
                        onClick={() => {
                          setPropertyId(property?.properties_id)
                          toggleiCalModal()
                        }}
                      >
                        Add ICal
                      </Button>
                    )}
                    {hasAccess('propertyAccess', getUserRole()) && (
                      <Button
                        className="btn btn-primary sky_btn"
                        type="button"
                        onClick={() => {
                          // setPropertyId(property?.properties_id)
                          navigate(`/clients/clientInfo/${client_id}/edit-property/${property?.properties_id}`)
                        }}
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                </div>
                <div>
                  <div className="count_main_div mb-2">
                    <div className="user_details_box mb-0">
                      <div className="icon_box_div">
                        <img className="img-fluid" src={ScheduleIcon} alt="Image" />
                      </div>
                      <h6>
                        <span className="black_color">Last Schedule: </span>
                        {property?.propertySchedule?.booking_date_time
                          ? getBookingDayjs(property?.propertySchedule, property?.propertySchedule?.properties?.timezone)?.format('DD MMM YYYY')
                          : 'N/A'}
                      </h6>
                    </div>
                    {hasAccess('cleanerServiceRates', getUserRole()) && (
                      <div>
                        <h6>
                          <span className="black_color">Cost Value</span>{' '}
                          <span className="gray_color">
                            {property?.total_value ? formatAmount(property?.total_value) : '-'}{' '}
                            {hasAccess('propertyValue', getUserRole()) && (
                              <i
                                className="fas fa-edit"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setPropertyId(property?.properties_id)
                                  setPropertyData(property)
                                  toggleTotalValueModal()
                                }}
                              ></i>
                            )}
                          </span>
                        </h6>
                      </div>
                    )}
                  </div>
                  <div className="count_main_div">
                    <div className="user_details_box mb-0">
                      <div className="icon_box_div">
                        <img className="img-fluid" src={CleanerUserIcon} alt="Image" />
                      </div>
                      <h6>
                        <span className="black_color">Main Cleaner: </span>
                        {property?.cleaners?.first_name ? `${property?.cleaners?.first_name} ${property?.cleaners?.last_name}` : '-'}{' '}
                        {hasAccess('mainCleanerEdit', getUserRole()) && (
                          <i
                            className="fas fa-edit"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setPropertyId(property?.properties_id)
                              setPropertyData(property)
                              toggleMainCleanerModal()
                            }}
                          ></i>
                        )}
                      </h6>
                    </div>

                    {hasAccess('cleanerServiceRates', getUserRole()) && (
                      <div>
                        <h6>
                          <span className="black_color">Cleaner Service Value:</span>{' '}
                          <span className="gray_color">
                            {property?.cleaner_service_value ? formatAmount(property?.cleaner_service_value) : '-'}{' '}
                            {hasAccess('cleanerServiceValue', getUserRole()) && (
                              <i
                                className="fas fa-edit"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setPropertyId(property?.properties_id)
                                  setPropertyData(property)
                                  toggleCleanerServiceValueModal()
                                }}
                              ></i>
                            )}
                          </span>
                        </h6>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <h4 className="not_found text-center">No Data Found</h4>
        )}
      </div>

      {showScheduleModal && (
        <CustomModal isOpen={showScheduleModal} toggle={toggleScheduleModal} title={`Create New Schedule`}>
          <AddEditSchedule
            propertyId={propertyId}
            setIsRefresh={setIsRefresh}
            client_id={client_id}
            toggleScheduleModal={toggleScheduleModal}
            cleaning_on={cleaning_on}
            setUpcomingRefresh={setUpcomingRefresh}
            propertyData={propertyData}
          />
        </CustomModal>
      )}

      {showiCalModal && (
        <CustomModal isOpen={showiCalModal} toggle={toggleiCalModal} title={`Add ICal`} size="md">
          <AddEditiCal
            propertyId={propertyId}
            setIsRefresh={setIsRefresh}
            client_id={client_id}
            toggleiCalModal={toggleiCalModal}
            disable={disableIcal}
          />
        </CustomModal>
      )}

      {/* Main Cleaner Modal */}
      {showMainCleanerModal && (
        <CustomModal isOpen={showMainCleanerModal} toggle={toggleMainCleanerModal} title={`Edit Main Cleaner`}>
          <EditMainCleaner
            propertyId={propertyId}
            setIsRefresh={setIsRefresh}
            client_id={client_id}
            toggleMainCleanerModal={toggleMainCleanerModal}
            propertyData={propertyData}
          />
        </CustomModal>
      )}

      {/* Total Value Modal */}
      {showTotalValueModal && (
        <CustomModal isOpen={showTotalValueModal} toggle={toggleTotalValueModal} title={`Edit Total Value`}>
          <EditTotalValue
            propertyId={propertyId}
            setIsRefresh={setIsRefresh}
            client_id={client_id}
            toggleTotalValueModal={toggleTotalValueModal}
            propertyData={propertyData}
          />
        </CustomModal>
      )}

      {/* Cleaner Service Value Modal */}
      {showCleanerServiceValueModal && (
        <CustomModal isOpen={showCleanerServiceValueModal} toggle={toggleCleanerServiceValueModal} title={`Edit Cleaner Service Value`}>
          <EditCleanerServiceValue
            propertyId={propertyId}
            setIsRefresh={setIsRefresh}
            client_id={client_id}
            toggleCleanerServiceValueModal={toggleCleanerServiceValueModal}
            propertyData={propertyData}
          />
        </CustomModal>
      )}
      <DeletePopup>
        <button type="reset" data-bs-dismiss="modal" className="w-100 btn btn-danger" onClick={() => onDelete()}>
          Delete
        </button>
      </DeletePopup>
    </>
  )
}

export default Property
